export default __webpack_public_path__ + "static/media/2.blur.ab94afa4.jpeg";